// [cursor 2026-06-01] S87-T4 finish-up: compact bookmark ribbon CTA dropped into
// RiskFlow cards, Bulletin posts, Desk rows, and Risk Signal rows. Saves durably
// via the bookmark bus; reflects a saved state and never double-saves.
import { useState } from "react";
import { Bookmark } from "lucide-react";
import { cn } from "../../lib/utils";
import { saveBookmark, type BookmarkSaveDetail } from "../../lib/bookmarks-bus";

interface BookmarkRibbonButtonProps {
  input: BookmarkSaveDetail;
  className?: string;
  title?: string;
  size?: number;
}

export function BookmarkRibbonButton({
  input,
  className,
  title = "Save bookmark",
  size = 13,
}: BookmarkRibbonButtonProps) {
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (busy || saved) return;
    setBusy(true);
    const record = await saveBookmark(input).catch(() => null);
    setBusy(false);
    if (record) setSaved(true);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={saved}
      title={saved ? "Saved to Bookmarks" : title}
      className={cn(
        "inline-flex h-6 w-6 items-center justify-center rounded-[4px] border border-transparent transition-colors disabled:opacity-50",
        saved
          ? "text-[var(--fintheon-accent)]"
          : "text-[var(--fintheon-text)]/40 hover:border-[var(--fintheon-accent)]/24 hover:text-[var(--fintheon-accent)]",
        className,
      )}
      disabled={busy}
    >
      <Bookmark size={size} fill={saved ? "currentColor" : "none"} />
    </button>
  );
}
